import BgOverlayComponent from './components/BgOverlayComponent';
import TestComponent from './components/TestComponent';
import UnderConstructionComponent from './components/UnderConstructionComponent';
import SessionTimeoutComponent from './components/SessionTimeoutComponent';
import AccessDeniedComponent from './components/AccessDeniedComponent';
import NonCatalogComponent from './components/NonCatalogComponent';
import FavOrderMainComponent from './components/FavOrderMainComponent';
import PunchoutComponent from './components/PunchoutComponent';
import OrderStatusComponent from './components/OrderStatusComponent';
import ShoppingCartComponent from './components/ShoppingCartComponent';
import ShopRedirectComponent from './components/ShopRedirectComponent';
import ItemDetailNewComponent from './components/ItemDetailNewComponent';
import OrderApprovalComponent from './components/OrderApprovalComponent';
import RequestorApprovalComponent from './components/RequestorApprovalComponent';
import ProfileComponent from './components/ProfileComponent';
import WaitingRequestorApprovalComponent from './components/WaitingRequestorApprovalComponent';
import SearchResultsComponent from './components/SearchResultsComponent'
import UserNotificationComponent from './components/UserNotificationComponent';
import FavItemMainComponent from './components/FavItemMainComponent';
import HomepageComponent from './components/HomepageComponent';
import SupplierCallInComponent from './components/SupplierCallInComponent';
import MMPickupOrderComponenet from './components/MMPickupOrderComponent';
import MMReceiveOrderComponent from './components/MMReceivingOrderComponent';
import CycleCountComponent from './components/CycleCountComponent';
import ReconComponent from './components/ReconComponent';
import ReplenishReviewComponent from './components/ReplenishReviewComponent';
import StockvalueComponent from './components/StockValueComponent';
import CCReportComponent from './components/CCReportComponent';
import RMAComponent from './components/RMAComponent';
import StockIssueComponent from './components/StockIssueComponent';
import MobileInventoryManagementComponent from './components/MobileInventoryManagementComponent';
import BinLabelComponent from './components/BinLabelComponent';
import ProductReplenComponent from './components/ProductReplenComponent';
import KenstanFormComponent from './components/KestanFormComponent'
import ItemMaintenanceAComponent from './components/ItemMaintenanceAComponent'
import ASNApprovalComponent from './components/ASNApprovalComponent'
import POWorkbenchComponent from './components/POWorkbenchComponent'
import ExpressPutAwayComponent from './components/ExpressPutAwayComponent';
import ManualStockAdjustmentComponent from './components/ManualStkAdjComponent';
import ItemHoldsComponent from './components/ItemHoldsComponent';
/*[2/24/22, PC_DP_03, Priyanka.D]*/
import DefaultPutAwayComponent from './components/DefaultPutAwayComponent';
import BinToBinComponent from './components/BinToBinComponent';
/*[01/30/22, PC_EF_02, Priyanka.D]*/
import EnersysFormComponent from './components/EnersysFormComponent';
import RcvRptComponent from './components/RcvRptComponent';
import TransSelectComponent from './components/TransSelectComponent';
import FedexShippingComponent from './components/FedexShippingComponent'
/*[02/10/22, Venkat]*/
import OpenPOReportComponent from './components/OpenPOReportComponent';
import RTVComponent from './components/RTVComponent';
import ReprintPackingSlipsComponent from './components/ReprintPackingSlipsComponent';
import MaterialStorageLocComponent from './components/MaterialStorageLocComponent';
/*[2/28/22, PC_DF_02 Priyanka.D]*/
import DoorFormComponent from './components/DoorFormComponent';
import RefSiteMaintenanceComponent from './components/RefSiteMaintenanceComponent';
import STKIssuesCartComponent from './components/STKIssuesCartComponent';
import LoadStageErrorComponent from './components/LoadStageErrorComponent';
import OrderEntryComponent from './components/OrderEntryComponent';
import SupplierOrderEntryComponent from './components/SupplierSuggestionComponent';
import FormsComponent from './components/FormsComponent';
import ManageFormComponent from './components/ManageFormComponent';
import AddFormComponent from './components/AddFormComponent';
import TrackingNoUpdateComponent from './components/TrackingNoUpdateComponent';
import InteractiveDiagramComponent from './components/InteractiveDiagramComponent';
import LabelByLocationComponent from './components/LabelByLocationComponent';
import BuildHistoryComponent from './components/BuildHistoryComponent';
import ReleaseNotesMaintenanceComponent from './components/ReleaseNotesMaintenanceComponent';
import AddVersionComponent from './components/AddVersionComponent';
import WALNonCatalogComponent from './components/WALNonCatalogComponent';
import SrcNonCatalogComponent from './components/SrcNonCatalogComponent';
import ContainerBarCodeComponent from './components/ContainerBarCodeComponent';
import ContainerPackingComponent from './components/ContainerPackingComponent';
import EquipmentComponent from './components/EquipmentComponent';
import FieldInventoryComponent from './components/FieldInventoryWorkBenchComponent';
import AcceptTransferComponent from './components/AcceptTransferComponent';

const route = [
    {
        path: "/ForgotPassword",
        component: BgOverlayComponent,
    },
    {
        path: "/ChangePassword",
        component: BgOverlayComponent,
    },
    {
        path: "/searchresults",
        component: SearchResultsComponent,
    },
    {
        path: "/needapprove",
        component: OrderApprovalComponent,
    },

    {
        path: "/needquote",
        component: WaitingRequestorApprovalComponent,
    },
    {
        path: "/approvequote",
        component: RequestorApprovalComponent,
    },
    {
        path: "/Shopredirect",
        component: ShopRedirectComponent,
    },
    {
        path: "/RFQEntry",
        component: NonCatalogComponent,

    },
    {
        path: "/HomePage",
        component: HomepageComponent,

    },
    {
        path: "/TestPage",
        component: TestComponent,

    },
    {
        path: "/favorder",
        component: FavOrderMainComponent,

    },
    {
        path: "/punchout",
        component: PunchoutComponent,

    },
    {
        path: "/sessiontimeout",
        component: SessionTimeoutComponent,

    },
    {
        path: "/underconstruction",
        component: UnderConstructionComponent,

    },
    {
        path: "/labelsbyloc",
        component: LabelByLocationComponent,
    },
    {
        path: "/replen",
        component: ReplenishReviewComponent,
    },
    {
        path: "/stockvaluerpt",
        component: StockvalueComponent,
    },
    {
        path: "/CycleCntReconRpt",
        component: CCReportComponent,
    },
    {
        path: "/InsiteonlineSTKIS",
        component: StockIssueComponent,
    },
    {
        path: "/ForgotPassword",
        component: BgOverlayComponent,
    },
    {
        path: "/BinLabelPrinting",
        component: BinLabelComponent,
    },
    /*[01/30/22, PC_EF_02, Priyanka.D]*/

    {
        path: "/enersysform",
        component: EnersysFormComponent,

    },
    /*[2/28/22, PC_DF_02, Priyanka.D]*/
    {
        path: "/DoorForm",
        component: DoorFormComponent,
    },
    {
        path: "/interactivediagram",
        component: InteractiveDiagramComponent,
    },

    

    /**
* Ref: SC_PC_02
* Importing the ShoppingCart which includes the shopping cart page.
*/
    {
        path: "/ShoppingCart",
        component: ShoppingCartComponent,
        //title: "shoppingcart"

    },
    {
        path: "/ItemDetailNew",
        component: ItemDetailNewComponent,

    },

    {
        path: "/orderstatus2",
        component: OrderStatusComponent,

    },

    {
        path: "/accessdenied",
        component: AccessDeniedComponent,

    },

    {
        path: "/profile",
        component: ProfileComponent,

    },
    {
        path: "/UserNotification",
        component: UserNotificationComponent,

    },
    {
        path: "/favorites",
        component: FavItemMainComponent,

    },
    {
        path: "/SupplierOrderEntry",
        component: SupplierCallInComponent,

    },
    {
        path: "/pickingassignto",
        component: MMPickupOrderComponenet,
    },
    //[9/26/22], Bug - 2696 - To make the receive items panel based on the previlege, Dhevanesam R
    {
        path: "/receiving",
        component: MMReceiveOrderComponent,
    },
    {
        path: "/cyclecount",
        component: CycleCountComponent,
    },
    {
        path: "/cyclecountrecon",
        component: ReconComponent,
    },
    /**
     * RMAR_PC_1
     * RMA panel
     * */
    {
        path: "/InsiteonlineRMA",
        component: RMAComponent,
    },
    {
        path: "/OrderItems",
        component: ProductReplenComponent,
    }, {
        path: "/kenstanform",
        component: KenstanFormComponent,
    }, 
    {
        path: "/addstockitems",
        component: ItemMaintenanceAComponent,
    },
    {
        path: "/SDIAsnEntry",
        component: ASNApprovalComponent,
    },
    /**
     * EPOR_PC_01
     * */
    {
        path: "/expedite",
        component: POWorkbenchComponent,
    },
    {
        path: "/ExpressPutawayLocation",
        component: ExpressPutAwayComponent,
    },
    {
        path: "/refsitemaintenance",
        component: RefSiteMaintenanceComponent,
    },
    {
        path: "/RcvRpt",
        component: RcvRptComponent,
    },
    {
        path: "/RTV",
        component: RTVComponent,
    },
    /**
     * TRR_PC_1
     * */
    {
        path: "/TransSelect",
        component: TransSelectComponent,
    },
    /**
     *MSA_PC_03*
     **/

    {
        path: "/ManualStockAdj",
        component: ManualStockAdjustmentComponent,
    },
    /**
     *[1/20/22, PC_IH_03, WW-320, Dhevanesam R]*
     **/

    {
        path: "/HoldItemList",
        component: ItemHoldsComponent,
    },
    /*[2/24/22, PC_DP_03, Priyanka.D]*/
    {
        path: "/PutawayPickingLocations",
        component: DefaultPutAwayComponent,

    },
    /***
     * BTB_PC_03 - Deepthi N H
     * */
    {
        path: "/BinToBinTransfer",
        component: BinToBinComponent,

    },
    /*
     * Venkat 02/10/2022
     
     */
    {
        path: "/postatus",
        component: OpenPOReportComponent,

    },

    {
        path: "/MaterialStorageLoc",
        component: MaterialStorageLocComponent,

    },
    /*
     * Tingyu Liu 02/15/2022
     
     */
    {
        path: "/fedexshipping",
        component: FedexShippingComponent,

    },
    {
        path: "/reprintPackN1",
        component: ReprintPackingSlipsComponent,

    },
    /***
     * R_STKC_
     * */
    {
        path: "/STKIssuesCart",
        component: STKIssuesCartComponent,

    },
    /***
    * LSER_PC_01
    * */
    {
        path: "/loadstageandputaway",
        component: LoadStageErrorComponent,

    },
    {
        path: "/AdvancedSupplierOrderEntry",
        component: OrderEntryComponent,

    },
    {
        path: "/suppliersuggestionpage",
        component: SupplierOrderEntryComponent,

    },
    {
        path: "/manageforms",
        component: ManageFormComponent,

    },
    {
        path: "/addforms",
        component: AddFormComponent,

    },
    /*[12/15/22], PC_WW-552_FE_1, Dhevanesam R*/
    {
        path: "/forms",
        component: FormsComponent,

    },
    {
        path: "/trackingnumberupd",
        component: TrackingNoUpdateComponent,

    },
    {
        path: "/buildversionhistory",
        component: BuildHistoryComponent
    },
    {
        path: "/srcnoncatalog",
        component: SrcNonCatalogComponent
    },
    /*[09/05/23, RNM_PC_04 Vishwa S]*/
    {
        path: "/releasenotesmaintenance",
        component: ReleaseNotesMaintenanceComponent
    },
    {
        path: "/addversioncomponent",
        component: AddVersionComponent
    },
    {
        path: "/mobileinventorymanagement",

        component: MobileInventoryManagementComponent
    },
    {
        path: "/walmartrfqentry",
        component: WALNonCatalogComponent
    },
    {
        path: "/printcntbarcode",
        component: ContainerBarCodeComponent
    },
    {
        path: "/containerpacking",
        component: ContainerPackingComponent
    }, {
        path: "/Equipments",
        component: EquipmentComponent
    }, {
        path: "/FieldInventoryWorkbench",
        component: FieldInventoryComponent
    }, {
        path: "/AcceptTransfer",
        component: AcceptTransferComponent
    },
    {
        path: "/underMaintanance",
        component: BgOverlayComponent
    },
    /**
     * Ref: LN_PC_03
     * Importing the BgOverlayComponent which includes Login and Forgot Password.
     */
    {
        path: "/",
        component: BgOverlayComponent,
        title: "ZEUS"

    }

]
export default route;